import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StandardLanding from '../../../shared/components/StandardLanding';
import TableCommunityAffairs from '../components/TableCommunityAffairs';
import { deleteCommunityAffair } from '../action';
import { getReportType, getCommunityAffairList } from '../../general/action';
import { getUnitList } from '../../user-accounts/action';

const Landing = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { reportType, loading, listCommunityAffair } = state.general;
    const { listUnit } = state.account;

    useEffect(() => {
        const name = 'community_affairs';
        dispatch(getReportType(name));
        dispatch(getCommunityAffairList());
        dispatch(getUnitList());
    }, []);

    return (
        <StandardLanding>
            <div className="main-container content-crop">
                <div className="flex justify-between">
                    <p className="lg-title text-blue-10">COMMUNITY AFFAIRS</p>
                    <p className="md-title text-gray-20">View tabulated summary of reports here</p>
                </div>
                <div className="mt-2">
                    <TableCommunityAffairs
                        loading={loading}
                        listUnit={listUnit}
                        reportType={reportType}
                        listCommunityAffair={listCommunityAffair}
                        deleteCommunityAffair={deleteCommunityAffair}
                        getCommunityAffairList={getCommunityAffairList}
                    />
                </div>
            </div>
        </StandardLanding>
    );
};

export default Landing;
